/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API48728Item {
  
  /** 里程牌计划编号 */
  planNo?: string;
  
  /** 里程牌标题 */
  title?: string;
  
  /** 里程牌说明 */
  remark?: string;
  
  /** 里程牌开始时间 */
  planStartDate?: any;
  
  /** 里程牌结束时间 */
  planEndDate?: any;
  
  /** 前置项目编号 */
  preProjectNo?: string;
  
  /** 前置项目名称 */
  preProjectName?: string;
  
  /** 前置项目里程牌编号 */
  preMilestoneNo?: string;
  
  /** 前置项目里程牌名称 */
  preMilestoneName?: string;
  
  /** 占比 */
  percentStr?: string;
  
  /**  */
  percentDou?: any;
  
  /**  */
  percent?: number;
  
};
    
  



export interface API48728Req {
  
  /** (String) */
  projectNo?: string;
    
};



export interface API48728Res {
  /** 项目编号  */
  projectNo?: string;
  /** 里程牌计划列表 ,ProjectPlanResp  */
  planList?: API48728Item[];
  
};


// 48728 查询项目下的计划列表详情

export interface IUseGetAPI48728Return {
  /** 查询项目下的计划列表详情: 接口请求状态 */
  isAPI48728Loading: boolean;
  /** 查询项目下的计划列表详情: 接口请求返回数据 */
  dataAPI48728: API48728Res;
  /**  查询项目下的计划列表详情: 接口数据请求方法 */
  fetchAPI48728Data:  (inputs: API48728Req, config?: YWRequestConfig) => Promise<API48728Res>;
  /** 查询项目下的计划列表详情: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48728 = ():IUseGetAPI48728Return => {
  let isMount = true;
  const [isAPI48728Loading, setIsAPI48728Loading] = useState(false);
  const [dataAPI48728, setDataAPI48728] = useState<API48728Res>({} as API48728Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/detail`;

  const fetchAPI48728Data = async (inputs: API48728Req, config?: YWRequestConfig): Promise<API48728Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48728Req>) || {}) as API48728Req;
    
  
    if ( isMount ) {
      setIsAPI48728Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48728Res>(`${basePath}/corp-admin/project/plan/detail?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48728(res || {} as API48728Res);
        setIsAPI48728Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48728Loading(false);
      }
      return false as unknown as API48728Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48728Loading,
    dataAPI48728,
    fetchAPI48728Data,
    requestUrl,
  }
}

